<template>
  <!-- 培训班报名表 编辑页面 -->
  <div class="container">
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item
          label="辞书培训班名称: "
          v-show="detailId"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.title"
              :disabled="detailId != ''"
              autocomplete="off"
              width="120px"
              :maxlength="maxlength"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="姓名: " prop="name" :label-width="formLabelWidth">
          <el-col :span="24">
            <el-input
              v-model="form.name"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入姓名"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="性 别: " prop="sex" :label-width="formLabelWidth">
          <el-col :span="4">
            <el-radio-group v-model="form.sex" :disabled="isView">
              <el-radio :label="'0'">男</el-radio>
              <el-radio :label="'1'">女</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item
          label="身份证号: "
          prop="idNumber"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.idNumber"
              :disabled="isView"
              autocomplete="off"
              placeholder="请输入身份证号"
            />
          </el-col>
        </el-form-item>
        <!-- <el-form-item
          label="手机号码: "
          prop="phonenumber"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.phonenumber"
              :disabled="isView"
              autocomplete="off"
              placeholder="请输入手机号码"
            />
          </el-col>
        </el-form-item> -->
        <el-form-item
          label="联系方式: "
          prop="landlineNumber"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.landlineNumber"
              :disabled="isView"
              autocomplete="off"
              placeholder="请输入电话"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="单 位: " prop="unit" :label-width="formLabelWidth">
          <el-col :span="24">
            <el-input
              v-model="form.unit"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入单位"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="职 务: " prop="post" :label-width="formLabelWidth">
          <el-col :span="24">
            <el-input
              v-model="form.post"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入职务"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="职 称: "
          prop="postTitle"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.postTitle"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入职称"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="邮 箱: "
          prop="email"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.email"
              :disabled="isView"
              autocomplete="off"
              placeholder="请输入邮箱"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="通讯地址: "
          prop="addr"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.addr"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入通讯地址"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="是否住宿: " prop="accommodate"  :label-width="formLabelWidth">
          <!-- <el-select
            style="width:100%"
            v-model="form.accommodate"
            :disabled="isView"
            placeholder="请选择是否住宿"
          >
            <el-option
              v-for="(item, index) in roomTypeList"
              :key="index"
              :label="item.type"
              :value="item.id"
            ></el-option>
          </el-select> -->
          <el-col :span="4">
            <el-radio-group v-model="form.accommodate" :disabled="isView">
              <el-radio :label="'1'">是</el-radio>
              <el-radio :label="'0'">否</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <!-- 发票类型 1 个人  2 单位 -->
        <el-form-item label="发票类型: " prop="invoiceType" :label-width="formLabelWidth">
          <el-col :span="12">
            <el-radio-group v-model="form.invoiceType" :disabled="isView">
              <el-radio :label="'1'">普通发票(电子票)</el-radio>
              <el-radio :label="'2'">专用发票(纸质票)</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <!-- 个人 -->
        <div v-if="form.invoiceType =='1'">
          <el-form-item
            label="发票抬头: "
            prop="invoiceUnit"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.invoiceUnit"
                :disabled="isView"
                autocomplete="off"
                :maxlength="maxlength"
                placeholder="请输入发票抬头"
              />
            </el-col>
          </el-form-item>
          <el-form-item
            label="单位纳税人税号: "
            prop="taxNumber"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.taxNumber"
                :disabled="isView"
                autocomplete="off"
                placeholder="请输入单位纳税人税号"
              />
            </el-col>
          </el-form-item>
        </div>

        <!-- 单位 -->
        <div v-if="form.invoiceType =='2'">
          <el-form-item
            label="发票抬头: "
            prop="invoiceUnit"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.invoiceUnit"
                :disabled="isView"
                autocomplete="off"
                :maxlength="maxlength"
                placeholder="请输入单位名称"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="单位纳税人税号: "
            prop="taxNumber"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.taxNumber"
                :disabled="isView"
                autocomplete="off"
                placeholder="请输入单位纳税人税号"
              />
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="增值税专用发票: " :label-width="formLabelWidth">
            <el-col :span="1">
              <el-checkbox v-model="form.isVat" disabled></el-checkbox>
            </el-col>
          </el-form-item> -->
          <!-- <div v-if="form.isVat"> -->
          <div>
          <el-form-item
            label="开户银行名称: "
            prop="openBank"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.openBank"
                :disabled="isView"
                autocomplete="off"
                :maxlength="maxlength"
                placeholder="请输入开户银行名称"
              />
            </el-col>
          </el-form-item>
          <el-form-item
            label="账 号: "
            prop="accountNumber"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.accountNumber"
                :disabled="isView"
                autocomplete="off"
                onkeyup="value=value.replace(/[^\d]/g,0)"
                placeholder="请输入增值税专用发票账号"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="地 址: "
            prop="invoiceAddr"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.invoiceAddr"
                :disabled="isView"
                autocomplete="off"
                :maxlength="maxlength"
                placeholder="请输入增值税专用发票地址"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="电 话: "
            prop="invoicePhonenumber"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.invoicePhonenumber"
                :disabled="isView"
                autocomplete="off"
                placeholder="请输入增值税专用发票电话"
              />
            </el-col>
          </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 修改状态: 0 已发布, 1 未发布 -->
      <div slot="footer" class="dialog-button" v-if="detailId">
         <el-button type="primary" v-show="isView"  @click="$router.push('/dictionary-train-apply')">
          返回列表
        </el-button>
        <el-button type="primary" class="confirm-button" :disabled="isView" @click="handelConfirm('form', 0)">
           保 存
        </el-button>
        <el-button class="confirm-button" :disabled="isView" @click="cancleHandelConfirm"
          >取 消</el-button
        >
      </div>
      <!-- <div slot="footer" class="dialog-button" v-else>
        <el-button type="primary" @click="handelConfirm('form', 0)">
          立即创建
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >取 消</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
// import { Message } from 'element-ui'
import DictionaryTrainApi from '@/api/dictionaryTrain'
import { mapRequestActions } from '@/utils'
export default {
  data () {
    return {
      loading: false,
      formLabelWidth: '150px',
      maxlength: 200,
      isView: !!this.$route.query.isView || false, // 判断预览
      detailId: this.$route.query.id || '',
      detailList: {},
      form: {
        title: '', // '培训班名称'
        name: '', // 姓名
        sex: '0', // 性别 0 男 1 女
        // phonenumber: '', // 手机号码
        landlineNumber: '', // 联系方式
        post: '', // 职务
        postTitle: '', // 职称,
        idNumber: '', // 身份证号
        unit: '', // 单位
        email: '', // 邮箱
        addr: '', // 通讯地址
        accommodate: '', // 是否住宿
        invoiceType: '1', // 发票类型 1 个人 2 单位
        invoiceUnit: '', // 发票抬头 或  单位单位抬头
        taxNumber: '', // 单位纳税人税号

        isVat: true, // 勾选 增值税专用发票  0 否 1 是

        openBank: '', // 开户银行名称
        accountNumber: '', // 增值税专用发票账号
        invoiceAddr: '', // 增值税专用地址
        invoicePhonenumber: '' // 增值税专用发票电话
      },
      rule: {
        name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        // phonenumber: [
        //   { required: true, message: '请输入手机号码', trigger: 'change' },
        //   {
        //     pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
        //     message: '请输入正确的手机号码'
        //   }
        // ],
        landlineNumber: [
          { required: true, message: '请输入联系方式', trigger: 'change' }
          // {
          //   pattern: /^0\d{2,3}-?\d{7,8}$/,
          //   message: '请输入正确的电话号码'
          // }
        ],
        post: [{ required: true, message: '请输入职务', trigger: 'change' }],
        postTitle: [{ required: true, message: '请输入职务', trigger: 'change' }],
        idNumber: [{ required: true, message: '请输入身份证号码', trigger: 'change' },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码'
          }
        ],
        unit: [{ required: true, message: '请输入单位', trigger: 'change' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'change' },
          {
            pattern: '^([a-z0-9A-Z]+[-_|\\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-zA-Z]{2,}$',
            message: '请输入正确的邮箱'
          }],
        addr: [{ required: true, message: '请输入通讯地址', trigger: 'change' }],
        accommodate: [{ required: true, message: '请选择是否住宿', trigger: 'change' }]
        // invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],

        // invoiceUnit: [{ required: true, message: '请输入发票抬头', trigger: 'change' }],
        // taxNumber: [{ required: true, message: '请输入单位纳税人税号', trigger: 'change' }, {
        //   pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/,
        //   message: '请输入正确的单位纳税人税号'
        // }],
        // openBank: [{ required: true, message: '请输入开户银行名称', trigger: 'change' }],

        // accountNumber: [
        //   { required: true, message: '请输入增值税专用发票账号', trigger: 'change' },
        //   {
        //     min: 12,
        //     max: 19,
        //     message: '请输入长度12～19个数字',
        //     trigger: 'change'
        //   }
        // ],
        // invoiceAddr: [{ required: true, message: '请输入增值税专用发票地址', trigger: 'change' }],
        // invoicePhonenumber: [{ required: true, message: '请输入增值税专用发票电话', trigger: 'change' },
        //   {
        //     pattern: /^0\d{2,3}-?\d{7,8}$/,
        //     message: '请输入正确的电话号码'
        //   }]
      }
    }
  },
  created () {
    if (this.detailId) {
      this.handleQueryDetailById()
    }
  },
  methods: {
    ...mapRequestActions(DictionaryTrainApi),
    handelConfirm (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑状态 且 点击发布
          if (this.detailId && type === 0) {
            /**
             * 逻辑: 1, 选择个人时, 清空单位选项中的input值
             * 2.选择单位时, (1) 增值税勾选时,直接提交   (2) 增值税未勾选时,清空增值税四项input值
             */
            // 选择发票类型  1, 个人(普通发票)  2  单位(专用发票)
            if (this.form.invoiceType === '1') {
              this.updateDetailAction({
                id: this.detailId,
                ...this.form,
                isVat: 0,
                status: type,
                taxNumber: this.form.taxNumber,
                openBank: '', // 开户银行名称
                accountNumber: '', // 增值税专用发票账号
                invoiceAddr: '', // 增值税专用地址
                invoicePhonenumber: '' // 增值税专用发票电话

              }).then((res) => {
                if (res.status) {
                  this.$message.success('编辑成功！')
                } else {
                  this.$message.error('操作失败')
                }
              })
            } else if (this.form.invoiceType === '2') {
              // 判断增值税 单选框 是否勾选
              // 1.勾选
              if (this.form.isVat) {
                this.updateDetailAction({
                  id: this.detailId,
                  ...this.form,
                  isVat: 1,
                  status: type
                }).then((res) => {
                  if (res.status) {
                    this.$message.success('编辑成功！')
                  } else {
                    this.$message.error('操作失败')
                  }
                })
              }
              //  else { // 2 没勾选
              //   this.updateDetailAction({
              //     id: this.detailId,
              //     ...this.form,
              //     isVat: 0,
              //     status: type,
              //     openBank: '', // 开户银行名称
              //     accountNumber: '', // 增值税专用发票账号
              //     invoiceAddr: '', // 增值税专用地址
              //     invoicePhonenumber: '' // 增值税专用发票电话
              //   }).then((res) => {
              //     if (res.status) {
              //       this.$message.success('编辑成功！')
              //     } else {
              //       this.$message.error('操作失败')
              //     }
              //   })
              // }
            }
          } else if (this.detailId && type === 1) {
            // 编辑状态 且 点击保存
            this.updateDetailAction({
              id: this.detailId,
              ...this.form,
              isVat: this.form.isVat === false ? 0 : 1,
              status: 1
            }).then((res) => {
              if (res.status) {
                this.$message.success('保存成功！')
              } else {
                this.$message.error('操作失败')
              }
            })
          }
          this.$router.push('/dictionary-train-apply')
        } else {
          // todo
        }
      })
    },
    /**
     * 点击取消
     */
    cancleHandelConfirm () {
      this.$router.push('/dictionary-train-apply')
    },

    async handleQueryDetailById () {
      const resultData = await this.queryDetailApplyByIdAction({
        id: this.detailId
      })
      if (resultData.status) {
        this.form = resultData.result || {}
        // this.form.isVat = resultData.result.isVat !== '0'
        this.form.isVat = true
      }
    },
    /**
     * 新建页面 -- 重置按钮
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      // this.$refs.upload.clearFiles()
      // this.fileList = []
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
}
.el-form {
  max-width: 80%;
  min-width: 800px;
  margin-right: auto;
  padding: 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  .address {
    /deep/ .el-form-item__label:before {
      content: "*" !important;
      color: #f56c6c !important;
      margin-right: 4px !important;
    }
  }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 135px;
    float: left;
    overflow: hidden;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
  }
}
.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;
  margin-left: 20%;
  margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
.el-col{
  text-align: left;
}
</style>
